var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/utils/getReferenceByNode.ts";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.values.js";
import { isBimCategoryNode, isBimElementNode, isBimFamilyNode, isBimModelNode, isBimStandardSizeNode } from "../../../classifier-service/Node";
export var getReferenceByNode = function getReferenceByNode(nodes, node) {
  return Object.values(nodes.ReferenceNode).find(function (_ref) {
    var element = _ref.element;

    if (node && isBimModelNode(node)) {
      return element.type === 'BimModelNode' && element.id === node.id;
    }

    if (node && (isBimCategoryNode(node) || isBimFamilyNode(node) || isBimElementNode(node) || isBimStandardSizeNode(node))) {
      return element.type === 'BimModelNode' && element.id === node.modelId;
    }
  }) || null;
};